module.exports = __webpack_public_path__ + "img/sem-imagem-publicidade2.38ae9828.jpg";